/* Minimal GiftFriend mutations.

   The auto-generated mutations in ./mutations.js select the nested `friend` and
   `gift` objects. Amplify does NOT resolve relational fields on a mutation
   response (the belongsTo resolver returns a stub), so requesting them yields
   "Cannot return null for non-nullable type 'ID' within parent 'Friend'", and
   aws-amplify rejects the whole promise even though the row was written. That
   broke optimistic UI in the assign flow. We only ever read scalar fields from
   these responses, so select just those. This file is hand-written; codegen
   only regenerates mutations.js / queries.js / subscriptions.js. */

export const createGiftFriend = /* GraphQL */ `
  mutation CreateGiftFriend($input: CreateGiftFriendInput!) {
    createGiftFriend(input: $input) {
      id
      friendId
      giftId
      purchased
      createdAt
      updatedAt
      owner
    }
  }
`;

export const updateGiftFriend = /* GraphQL */ `
  mutation UpdateGiftFriend($input: UpdateGiftFriendInput!) {
    updateGiftFriend(input: $input) {
      id
      purchased
      createdAt
      updatedAt
      owner
    }
  }
`;

export const deleteGiftFriend = /* GraphQL */ `
  mutation DeleteGiftFriend($input: DeleteGiftFriendInput!) {
    deleteGiftFriend(input: $input) {
      id
    }
  }
`;
